import { render, staticRenderFns } from "./survey-records.vue?vue&type=template&id=c60a51fa&scoped=true"
import script from "./survey-records.vue?vue&type=script&lang=ts"
export * from "./survey-records.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60a51fa",
  null
  
)

export default component.exports